import React from 'react'
import styled from 'styled-components'
import SectionTitle from 'src/components/SectionTitle'
import { Button, Input } from 'semantic-ui-react'
import { AppContext } from 'src/context/AppContext'

const toTypes = {
  channel: {
    displayLabel: '＃',
    placeholder: 'channel',
    disabled: false
  },
  member: {
    displayLabel: '＠',
    placeholder: 'someone',
    disabled: false
  },
  me: {
    displayLabel: '＠',
    placeholder: 'me',
    disabled: true
  }
}

const Destination = () => (
  <AppContext.Consumer>
    {({ state, actions }) => (
      <React.Fragment>
        <SectionTitle>宛先</SectionTitle>
        <CheckButton
          basic
          color={'blue'}
          compact
          onClick={actions.selectTo('channel')}
        >
          #channel
        </CheckButton>
        <CheckButton
          basic
          color={'blue'}
          compact
          onClick={actions.selectTo('member')}
        >
          @someone
        </CheckButton>
        <CheckButton
          basic
          color={'blue'}
          compact
          onClick={actions.selectTo('me')}
        >
          me
        </CheckButton>
        <StyledInput
          label={toTypes[state.toType].displayLabel}
          name={'to'}
          type={'text'}
          error={state.submitted && !state.to}
          placeholder={toTypes[state.toType].placeholder}
          value={state.toType === 'me' ? 'me' : state.to}
          onChange={actions.onChangeInput}
          disabled={toTypes[state.toType].disabled}
        />
      </React.Fragment>
    )}
  </AppContext.Consumer>
)

export default Destination

const CheckButton = styled(Button)`
  && {
    margin-bottom: 16px;
    margin-right: 8px;
  }
`

const StyledInput = styled(Input)`
  && {
    width: 100%;
  }
`
